import { createBrowserRouter, redirect } from "react-router-dom";
import App from './App';
import Register,{userRegister} from './pages/Register'
import Login,{ logIn as log_in, loader as login_loader } from './pages/Login'
import SearchOfResolveJudgments,{loader as search_of_resolve_judgments_loader} from "./pages/SearchOfResolveJudgments";
import Home,{ loader as home_loader} from "./pages/Home";

import React from "react";
import DigitalPublications,{loader as publications_digital_loader} from "./pages/DigitalPublications";
import DigitalPublicationsRecords,{loader as publicationsRecords_loader} from "./pages/DigitalPublicationsRecords";
import HistoryResolveJudgments,{loader as History_loader} from "./pages/HistoryResolveJudgments";
import ViewPDF from "./components/ViewPDF";
import PagViewPDF from "./pages/ViewPDF";
import ResetPassword from "./pages/ResetPassword";
import ResetPasswordToken from "./pages/ResetPasswordToken";
import Mission from "./pages/Mission";
import Profile,{ loader as profile_loader} from "./pages/Profile";


const router = createBrowserRouter([
    {
      path    : "/",
      element : <App/>,
      children:[
        {
          path    : "/",
          element : <Home/>,
          loader  : home_loader
        },
        {
          path  : "mission",
          element : <Mission />
        },
        {
          path    : "search_of_resolved_judgments",
          element : <SearchOfResolveJudgments/>,
          loader  : search_of_resolve_judgments_loader
        },
        {
          path    : "digital_publications",
          element : <DigitalPublications/>,
          loader  : publications_digital_loader,
          children:[
            {
              path    : ":category",
              loader  : ({params})=>{
                return redirect(`/digital_publications/${params.category}/1`)
              }
            },
            {
              path    : ":category/:pag",
              element : <DigitalPublicationsRecords/>,
              loader  : publicationsRecords_loader
            }
          ] 
        },
        {
          path    : "history_of_resolved_judgments",
          element : <HistoryResolveJudgments />,
          loader  : History_loader,
          children:[
            {
              path    : ":id_sentence",
              element : <ViewPDF path='assets/documents/resolved_judgments/historical/pdf'/>
            }
          ]
        },
        {
          path    : "profile",
          element : <Profile />,
          loader : profile_loader,
          action : ()=> alert("soy el submit")
        }
      ]
    },
    {
      path    : "digital-publications-view/:id",
      element : <PagViewPDF path='assets/documents/publications/boletines' />,
    },
    {
      path    : "sentence-view/:id",
      element : <PagViewPDF path='assets/documents/resolved_judgments/original/pdf' />
    },
    {
      path    : "login",
      element : <Login />,
      loader  : login_loader,
      action  : log_in
    },
    { 
      path    : "register", 
      element : <Register/>, 
      action  : userRegister
    },
    {
      path    : "reset-password",
      element : <ResetPassword />
    },
    {
      path    : "reset-password/:token",
      element : <ResetPasswordToken />
    }
  ]);

export default router